import http from '@/utils/http';
const call=async(action,data)=>{const response=await http({url:'/api/admin/v1/contractProjectFulfillmentProductPlan/'+action,data,method:'post'});if(response?.code!==0)throw Error(response?.msg||'计划请求失败');return response.data;};
export default Object.fromEntries(['detail','save'].map(action=>[action,data=>call(action,data)]));
